module.exports = __webpack_public_path__ + "img/Unidad8-2.f92e8c3b.png";